import { useQuery } from '@apollo/client';
import type { FetchFlagKpIsQuery } from '@generated/graphql';
import { useMemo } from 'react';
import { FETCH_FLAG_KPIS } from '../utils/flags.queries';
import { SPOTLIGHT_TYPES } from '../utils/reconFlags.config';

export const useReconFlagsKpiCounts = (
  organizationId?: string,
): {
  kpiCounts: Record<string, number>;
  orgTotalFlags: number;
  unresolvedThreePlusCount: number;
  refetch: () => Promise<unknown>;
} => {
  const { data: kpiQueryData, refetch } = useQuery<FetchFlagKpIsQuery>(
    FETCH_FLAG_KPIS,
    {
      skip: !organizationId,
      variables: { organizationId: organizationId ?? '' },
      fetchPolicy: 'cache-and-network',
    },
  );
  const kpis = kpiQueryData?.fetchFlagKPIs;

  const kpiCounts = useMemo(() => {
    const byType = new Map(
      (kpis?.typeCounts ?? []).map((row) => [row.flagType, row.count]),
    );
    return Object.fromEntries(
      SPOTLIGHT_TYPES.map(({ type }) => [type, byType.get(type) ?? 0]),
    ) as Record<string, number>;
  }, [kpis?.typeCounts]);

  const orgTotalFlags = kpis?.totalFlags ?? 0;
  const unresolvedThreePlusCount = kpis?.unresolvedOverThreeDays ?? 0;

  return { kpiCounts, orgTotalFlags, unresolvedThreePlusCount, refetch };
};
